// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1OFvF","signatureButtonsRight":"ModalSign_signatureButtonsRight__1YU8u"};